import React from 'react'

const CollegeApplication = () => {
  return (
    <div>CollegeApplication</div>
  )
}

export default CollegeApplication